let genderTypes = [
  { value: "MALE", label: "Homme" },
  { value: "FEMALE", label: "Femme" },
];

export default genderTypes;
